import { render } from "./DriveFolderSettingsPopUp.vue?vue&type=template&id=ab804fe0&scoped=true&ts=true"
import script from "./DriveFolderSettingsPopUp.vue?vue&type=script&lang=ts"
export * from "./DriveFolderSettingsPopUp.vue?vue&type=script&lang=ts"

import "./DriveFolderSettingsPopUp.vue?vue&type=style&index=0&id=ab804fe0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab804fe0"]])

export default __exports__